import type { FaireProductEntity } from "../../entity_types/product";

export const p_2bm3krvdtb: FaireProductEntity = {
  token: "p_2bm3krvdtb",
  type: "product",
  name: "mushrooms paintable watercolor notecard set",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/9177c9cc74f8110bb762cff23152aa7a0f1b6e370860daea2f94799e4bd2d1a9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/555c53659eb54b5357c3d3f7f575c43a01fc1055741aeaae26a2d9c0bf5f8ead.jpeg",
    "https://cdn.faire.com/fastly/ec4349ec016a063a09a2bf057eae3922a90060eadd7fec69c6f69bfc277fad73.jpeg",
    "https://cdn.faire.com/fastly/a9269a9363fc1ff2fedaac2027b12873a9441d7bde854d318a3bcb8a30437600.jpeg",
    "https://cdn.faire.com/fastly/b28d9d8c1f8d3ffb2550d81aaf6bdf1a4103d37fa07db8908f817b34b9deada5.jpeg",
    "https://cdn.faire.com/fastly/2c9ca6a33d1d463224624f913572bb3abc86d05387260a111ec92a280dce4dde.jpeg",
    "https://cdn.faire.com/fastly/d5ee2c330d7faacfe89b75086451925416f463118f2a7000cac07794169907ae.jpeg",
  ],
  priceDollars: 9,
  description:
    "An evergreen style with a devoted following — reorders consistently. Customers paint the cards themselves and send them — simple instructions included.\n\nIllustrations: four mushroom varieties.\n\n$9 wholesale · $18 retail · set of eight notecards + envelopes\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:09.909Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
